/* Built In Imports */
/* External Imports */
import { Box, Text } from '@chakra-ui/react';
/* Internal Imports */
/* Components */
import config from '@config';
/* Styles */
import styles from "@lb/Sections/aboutDevi/styles.module.css"
/* Services */

const AboutDeviSlide12 = ({ section }) => {
  return (
    <Box bgColor="#000" className={styles.section12Bg}>
      <Box
        maxW="1200px"
        mx="auto"
        minH="100vh"
        display="flex"
        position="relative"
        alignItems="center"
        flexDir={{ base: 'column', lg: 'row' }}
      >
        <Box
          maxW="366px"
          w={{ base: '90%', md: '100%' }}
          textAlign="center"
          mr={{ base: '0px', md: '34px' }}
          p="2rem"
        >
          <Text color="#D09700" fontSize={{ base: '18px', lg: '24px' }}>
            {section?.sectionContent[0]?.text}
          </Text>
        </Box>
        <Box
          maxW="800px"
          w="100%"
          textAlign="center"
          background={`#000 url(${config.imgPath}/d/46272/1684474066-the_source_of_creation_slide_1.jpg) no-repeat center center`}
          backgroundSize="contain !important"
          display="block"
          minH={{ base: '60vh', lg: '100vh' }}
        ></Box>
      </Box>
    </Box>
  );
};
export default AboutDeviSlide12;
